import { action } from 'satcheljs';
import type { DiagnosticDataLevel } from '../store/schema/PrivacySettings';

export const setDiagnosticDataLevel = action(
    'setDiagnosticDataLevel',
    (diagnosticDataLevel: DiagnosticDataLevel) => ({ diagnosticDataLevel })
);
